import React, { useEffect } from 'react'

type IdentigradientProps = {
  radius: number
  seed: string
}

const Identigradient = ({ radius: r, seed: s }: IdentigradientProps): JSX.Element => {
  const [color1, setColor1] = React.useState('rgba(0,0,0,0.0)')
  const [color2, setColor2] = React.useState('rgba(0,0,0,0.0)')

  useEffect(() => {
    sha256(s).then((hash) => {
      setColor1(`hsl(${(hash[0] / 256) * 360}deg, ${100}%, ${3 * (hash[1] / 256 / 4) * 100}%)`)
      setColor2(`hsl(${(hash[2] / 256) * 360}deg, ${100}%, ${((3 * hash[3]) / 256 / 4) * 100}%)`)
    })
  }, [s])

  return (
    <div
      style={{
        height: r,
        width: r,
        borderRadius: '50%',
        background: `radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.1) 50%, rgba(255, 255, 255, 0.3) 100%), linear-gradient(135deg, ${color1}, ${color2})`,
      }}
    ></div>
  )
}

export async function sha256(message: string): Promise<number[]> {
  const bytes = new TextEncoder().encode(message)
  const hash = await crypto.subtle.digest('SHA-256', bytes)
  return Array.from(new Uint8Array(hash))
}

export default Identigradient
